import gql from 'graphql-tag';
import { WorkOrderFragment } from '@app/pages/cmms/graphql/work-order.queries';

export const CreateWorkOrderMutation = gql`
	mutation CreateWorkOrder(
		$name: String!
		$priority: Int
		$category: WorkOrderCategories
		$deadline: DateTime
		$status: WorkOrderStatus
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$approver: UUID
		$approverType: UserGroupEnum
		$description: String
		$files: [UUID]
		$incidents: [UUID]
		$requests: [UUID]
		$routineData: InputRoutineType
		$locations: [LocationInput]
		$assets: [AssetInput]
		$coordinates: DigitalTwinCoordinatesInput
		$checklists: [WorkOrderCreateChecklistInput]
		$deviationType: DeviationTypeChoices
		$costOfWork: Decimal
		$costAllocation: CostAllocationChoices
		$timeframe: TimeframeChoices
		$labels: [UUID]
		$parentWorkOrder: UUID
	) {
		createWorkOrder(
			name: $name
			priority: $priority
			locations: $locations
			category: $category
			deadline: $deadline
			status: $status
			assignee: $assignee
			assigneeType: $assigneeType
			approver: $approver
			approverType: $approverType
			description: $description
			files: $files
			incidents: $incidents
			requests: $requests
			routineData: $routineData
			assets: $assets
			coordinates: $coordinates
			checklists: $checklists
			deviationType: $deviationType
			costOfWork: $costOfWork
			costAllocation: $costAllocation
			timeframe: $timeframe
			labels: $labels
			parentWorkOrder: $parentWorkOrder
		) {
			success
			workOrder {
				...WorkOrderFragment
				coordinates {
					x
					y
					z
				}
			}
		}
	}
	${WorkOrderFragment}
`;

export const EditWorkOrderMutation = gql`
	mutation EditWorkOrder(
		$pk: UUID!
		$name: String
		$priority: Int
		$status: WorkOrderStatus
		$category: WorkOrderCategories
		$deadline: DateTime
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$approver: UUID
		$approverType: UserGroupEnum
		$description: String
		$files: [UUID]
		$incidents: [UUID]
		$workOrders: [UUID]
		$requests: [UUID]
		$routineData: InputRoutineType
		$locations: [LocationInput]
		$assets: [AssetInput]
		$checklists: [WorkOrderCreateChecklistInput]
		$coordinates: DigitalTwinCoordinatesInput
		$deviationType: DeviationTypeChoices
		$costOfWork: Decimal
		$costAllocation: CostAllocationChoices
		$timeframe: TimeframeChoices
		$labels: [UUID]
		$setIncidents: [UUID]
		$setRequests: [UUID]
		$setFiles: [UUID]
	) {
		editWorkOrder(
			pk: $pk
			name: $name
			priority: $priority
			locations: $locations
			category: $category
			deadline: $deadline
			status: $status
			assignee: $assignee
			assigneeType: $assigneeType
			approver: $approver
			approverType: $approverType
			description: $description
			files: $files
			incidents: $incidents
			workOrders: $workOrders
			requests: $requests
			routineData: $routineData
			assets: $assets
			checklists: $checklists
			coordinates: $coordinates
			deviationType: $deviationType
			costOfWork: $costOfWork
			costAllocation: $costAllocation
			timeframe: $timeframe
			labels: $labels
			setIncidents: $setIncidents
			setRequests: $setRequests
			setFiles: $setFiles
		) {
			success
			workOrder {
				...WorkOrderFragment
				coordinates {
					x
					y
					z
				}
			}
		}
	}
	${WorkOrderFragment}
`;

export const DeleteWorkOrderMutation = gql`
	mutation DeleteWorkOrder($pk: UUID!) {
		deleteWorkOrder(pk: $pk) {
			success
		}
	}
`;

export const DeleteWorkOrdersMutation = gql`
	mutation DeleteWorkOrders($workOrders: [UUID]!) {
		deleteWorkOrders(workOrders: $workOrders) {
			success
		}
	}
`;

export const UnlinkWorkOrderObjects = gql`
	mutation UnlinkWorkOrderObjects(
		$pk: UUID!
		$incidents: [UUID]
		$requests: [UUID]
		$workOrders: [UUID]
	) {
		unlinkWorkOrderObjects(
			pk: $pk
			incidents: $incidents
			requests: $requests
			workOrders: $workOrders
		) {
			success
		}
	}
`;

export const DeleteChecklistMutation = gql`
	mutation DeleteChecklist($ids: [UUID]!) {
		deleteChecklists(checklists: $ids) {
			success
		}
	}
`;

export const UpdateChecklistMutation = gql`
	mutation UpdateChecklist($pk: UUID!, $template: JSONString) {
		editChecklist(pk: $pk, template: $template) {
			success
		}
	}
`;

export const CopyWorkOrderMutation = gql`
	mutation CopyWorkOrderMutation(
		$workOrders: [UUID]!
		$locations: [LocationInput]
		$copyAssignee: Boolean
		$copyApprover: Boolean
		$copyDeadline: Boolean
		$copyAssets: Boolean
		$copyCategory: Boolean
		$copyChecklists: Boolean
		$copyLabels: Boolean
		$copyPriority: Boolean
		$copyRoutine: Boolean
		$copyFiles: Boolean
		$copyIncidents: Boolean
		$copyRequests: Boolean
	) {
		copyWorkOrders(
			workOrders: $workOrders
			locations: $locations
			copyAssignee: $copyAssignee
			copyApprover: $copyApprover
			copyDeadline: $copyDeadline
			copyAssets: $copyAssets
			copyCategory: $copyCategory
			copyChecklists: $copyChecklists
			copyLabels: $copyLabels
			copyPriority: $copyPriority
			copyRoutine: $copyRoutine
			copyFiles: $copyFiles
			copyIncidents: $copyIncidents
			copyRequests: $copyRequests
		) {
			success
		}
	}
`;
